import React, { useEffect } from "react";
import "./styles.scss";
import { NewsGroup, RelatedJobsCard } from "../../../components";
import { withRouter } from "react-router-dom";
// import { getNewsByCategoryPage } from "../../news/service/news.service";
// import { getCategoryById } from "../../CreateNewItem/CreateNewCategory/service/category.service";
import { getLanguage } from "../../../utils/environment";
import { useDispatch, useSelector } from "react-redux";
import { getJobByGazetteDate } from "../../CreateNewItem/CreateNewGazette/service/jobs.service";

const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [job, setJob] = React.useState([]);

  const dispatch = useDispatch();
  const { jobCategoryList } = useSelector(({ jobsReducer }) => jobsReducer);

  // const newsList = useSelector((state) => state.newsReducer.newsList);

  useEffect(() => {
    async function fetchPageData() {
      try {
        const getJobs = await getJobByGazetteDate(props.date);
        console.log("Get Jobs by gazette Date", getJobs);

        if (getJobs?.data?.jobs.length > 0) {
          // dispatch(setNewsList(getNews?.data));
          setJob(getJobs?.data?.jobs);
        } else {
          console.error("No data found for related jobs");
        }
      } catch (error) {
        console.error("Error fetching page data:", error);
      }
    }
    console.log(props.date);

    if (props.date) {
      fetchPageData();
    }
  }, [props.date]);

  const fetchTagName = (id) => {
    const isExist = jobCategoryList?.find((x) => x?.job_category_id === id);
    console.log({ isExist });
    return isExist?.jobs_category_name;
  };

  return (
    <>
      {job && job.length > 0 && (
        <NewsGroup
          data={{
            titleName: "Related jobs",
            type: "en",
            linkName: "",
          }}
          // onClickViewNews={() => {
          //   props.history.push("/" + categoryId);
          //   props.setMenuName(categoryId);
          // }}
        >
          {Array.isArray(job) && job.length > 0 ? (
            job.map((data, index) => (
              <RelatedJobsCard
                data={{
                  img_url: data?.banner_img?.file_url || data?.banner_img,
                  titleEn: data?.job_title?.en,
                  titleSi: data?.job_title?.si,
                  content: data?.content,
                  organization: fetchTagName(data?.organization) || "",
                  closingDate: data?.closing_date,
                  views: data?.views || 0,
                  isArrow: true,
                }}
                onClick={() => {
                  if (data?.keywords) {
                    props.history.push(
                      `/jobs/${data?.keywords}/${data?.job_id}`,
                    );
                  } else {
                    const generatedSlug = data.job_title?.["si"]
                      ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                      ?.replace(/\s*-\s*/g, " ")
                      ?.replace(/\s*–\s*/g, " ")
                      ?.trim()
                      .split(/\s+/)
                      .slice(0, 5)
                      .join("-")
                      .replace(/-+/g, "-");
                    props.history.push(
                      `/jobs/${generatedSlug}/${data?.job_id}`,
                    );
                  }
                }}
              />
            ))
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              <h6 className="text-muted">No Related Jobs Available</h6>
            </div>
          )}

          {/* <TrendingNewsCard
          data={{
            isBorder: true,
            isTrendingNo: true,
            trendingNo: "2",
            isDate: false,
            header: "මහ බැංකුව පොලී අඩු කරයි.",
            content: "හිටපු ජනපතිවරුන්ගේ විදෙස් සංචාර සඳහා වැය වූ...",
          }}
          // onClick={() => {}}
        />
        <TrendingNewsCard
          data={{
            isBorder: true,
            isTrendingNo: true,
            trendingNo: "3",
            isDate: false,
            header: "මහ බැංකුව පොලී අඩු කරයි.",
            content: "හිටපු ජනපතිවරුන්ගේ විදෙස් සංචාර සඳහා වැය වූ...",
          }}
          // onClick={() => {}}
        /> */}
        </NewsGroup>
      )}
    </>
  );
};
export default withRouter(Index);
// export default Index;
